export default "__VITE_ASSET__CPwbNoLm__"